export default "__VITE_ASSET__C997oPSc__"